<div class="modal-container" (click)="closeModal()">
    <div class="image-wrapper" #imageContainer (click)="$event.stopPropagation()" style="position: relative;">
        <img [src]="urlServerLaraMedia+image?.src" [alt]="image?.title || 'Immagine'" />
    </div>
    <button class="btn btn-danger" style="position: absolute; top: 5px; right: 5px; opacity: 0.9;"
        (click)="closeModal()">
        <i class="bi bi-x" style="color: white;"></i>
    </button>
</div>